// Port of api/fuel/app/classes/insights/collection/overview.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'overview',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var baseCount = owner.get_count_collection_games()

        var overview = {
            total: baseCount,
            expansions: owner.get_count_collection_expansions(),
            prevowned: 0,
            collectionAvg: 0,
            playedPercent: 0,
            playedAvg: 0,
            played10: 0,
            ratedPercent: 0,
            ratedAvg: 0,
            ratedDifference: 0
        }

        if (owner.get_count_collection()) {

            // percentage of games turned over
            if (type === Constants.TYPE_USER) {

                overview.prevowned = Util.queryFast('SELECT SUM(c.collection_prevowned) AS s FROM collection c WHERE c.user_id IN(' + Util.in(userIndex) + ')')[0].s || 0
                overview.prevowned = Math.round((overview.prevowned / owner.get_count_collection()) * 1000) / 10

            } else {

                overview.collectionAvg = Math.round(Util.queryFast('SELECT COUNT(c.collection_id) AS s FROM collection c WHERE c.collection_own = 1 AND c.user_id IN(' + Util.in(userIndex) + ')')[0].s / userIndex.length)

            }

            // play stats
            if (owner.get_count_plays()) {

                var baseIn = Util.in(this._data.base)

                var played = Util.queryFast('SELECT COUNT(DISTINCT p.game_id) AS g FROM play p WHERE p.user_id IN(' + Util.in(userIndex) + ') AND p.game_id IN(' + baseIn + ')')

                overview.playedPercent = (100 / baseCount) * played[0].g

                if (type === Constants.TYPE_USER) {

                    overview.playedAvg = Math.round((Util.queryFast('SELECT SUM(p.play_count) AS sum FROM play p WHERE p.user_id IN(' + Util.in(userIndex) + ') AND p.game_id IN(' + baseIn + ')')[0].sum || 0) / baseCount * 10) / 10

                    overview.played10 = Util.queryFast('SELECT p.game_id AS s FROM play p WHERE p.user_id IN(' + Util.in(userIndex) + ') AND p.game_id IN(' + baseIn + ') GROUP BY p.game_id HAVING SUM(p.play_count) >= 10').length

                } else {

                    overview.playedAvg = Math.round((Util.queryFast('SELECT SUM(c.collection_plays) AS sum FROM collection c WHERE c.user_id IN(' + Util.in(userIndex) + ') AND c.collection_expansion = 0 AND c.collection_own = 1')[0].sum || 0) / baseCount * 10) / 10

                    overview.played10 = Util.queryFast('SELECT c.game_id AS s FROM collection c WHERE c.user_id IN(' + Util.in(userIndex) + ') AND c.game_id IN(' + baseIn + ') AND c.collection_plays >= 10 GROUP BY c.game_id').length

                }

            }

            // rating stats
            if (owner.get_count_ratings()) {

                var baseIn2 = Util.in(this._data.base)

                overview.ratedPercent = (100 / baseCount) * (Util.queryFast('SELECT COUNT(DISTINCT r.game_id) AS sum FROM rating r WHERE r.user_id IN(' + Util.in(userIndex) + ') AND r.game_id IN(' + baseIn2 + ')')[0].sum || 0)

                var unownedAvg

                if (type === Constants.TYPE_USER) {

                    overview.ratedAvg = Math.round((Util.queryFast('SELECT AVG(r.rating_value) AS avg FROM rating r WHERE r.user_id IN(' + Util.in(userIndex) + ') AND r.game_id IN(' + baseIn2 + ')')[0].avg || 0) * 100) / 100

                    unownedAvg = Math.round((Util.queryFast('SELECT AVG(r.rating_value) AS avg FROM rating r WHERE r.user_id IN(' + Util.in(userIndex) + ') AND r.game_id NOT IN(' + baseIn2 + ')')[0].avg || 0) * 100) / 100

                } else {

                    overview.ratedAvg = Math.round((Util.queryFast('SELECT AVG(c.collection_rating) AS avg FROM collection c WHERE c.user_id IN(' + Util.in(userIndex) + ') AND c.collection_expansion = 0 AND c.collection_own = 1 AND c.collection_rating > 0')[0].avg || 0) * 100) / 100

                    unownedAvg = Math.round((Util.queryFast('SELECT AVG(r.rating_value) AS avg FROM rating r WHERE NOT EXISTS(SELECT * FROM collection c WHERE c.user_id = r.user_id AND c.game_id = r.game_id AND c.collection_own = 1) AND r.user_id IN(' + Util.in(userIndex) + ') AND r.game_id IN(' + baseIn2 + ')')[0].avg || 0) * 100) / 100

                }

                overview.ratedDifference = Math.round((overview.ratedAvg - unownedAvg) * 10) / 10

            }

        }

        return {
            overview: overview
        }

    }
})
